import React, { useState, useRef, useEffect } from 'react';
import './SelectMsg.css';

export default function SelectMsg({ prompt, options, multi, presetKey, onSubmit, fromStep, steps, num_step }) {
  const [selected, setSelected] = useState(multi ? [] : null);

  const handleClick = (id) => {
    if (multi) {
      setSelected(prev => (
        prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
      ));
    } else {
      setSelected(id);
    }
  };

  const handleSubmit = () => {
    console.log('🎯 Submit Clicked', selected, presetKey, fromStep, steps, num_step);
    onSubmit(selected, presetKey, fromStep, steps, num_step);
  };

  return (
    <div className="select-msg">
      <p>{prompt}</p>
      <div className="select-options">
        {options.map(opt => (
          <button
            key={opt.id}
            onClick={() => handleClick(opt.id)}
            className={multi
              ? selected.includes(opt.id) ? 'selected' : ''
              : selected === opt.id ? 'selected' : ''}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <button className="confirm-btn" onClick={handleSubmit} disabled={multi ? selected.length === 0 : !selected}>
        Confirm Selection
      </button>
    </div>
  );
}